/** Vycet reprezentujici jednotlive typy zarovnani */
export enum AlignType {
    left,
    right,
    top,
    bottom,
    client,
    none,
}

export enum RequiredType {
    required,
    postponed,
    recommended,
    none,
}

export enum DisplayFormat {
    int,
    money,
    double,
    none,
}

export enum StretchType {
    none,
    vertical,
    horizontal,
    both,
}
/*
 * Výčet stavu pro hodnotu fake komponenty zobrazené při hromadném výběru.
 * U Fake pro multieditaci je potřeba rozlišit, jestli hodnota "null" byla nastavena v reakci na to že uživatel vymaže
 * hodnotu fake nebo byla načtena datasourcem jako hodnota atributu.
 */
export enum FakeComponentValueState {
    /** Neutrální stav, měl by nastat při resetu fake komponenty */
    notSet,
    /** Atribut má neprázdnou hodnotu. */
    userChanged,
    /** Atribut má prázdnou hodnotu, protože uživatel vymazal hodnotu na fake komponentě */
    userCleared,
}
